import { createApi } from '@/api'
export default {
  produceList: config => createApi(`/produce/pageSearch`, 'post', config), // 农产品列表
  produceDetail: config => createApi(`/produce/get`, 'get', config), // 农产品详情
  addproduce: config => createApi(`/produce/add`, 'post', config), // 农产品添加
  deleteproduce: config => createApi(`/produce/delete`, 'delete', config), // 农产品删除
  updateproduce: config => createApi(`/produce/update`, 'post', config) // 农产品修改
}



// WEBPACK FOOTER //
// ./src/views/produceManage/api/index.js